import { useRef, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setAnsweringInfoAction } from "../../../../redux/answeringQuestions/answeringInfo";
import { setTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import createTimer from "../../../../utils/createTimer";

const Timer = ( props ) => {

  const totalAnsweringTimer = useRef();
  const answeringTimer = useRef();

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setAnsweringInfo = payload => { dispatch( setAnsweringInfoAction( payload ) ) };
  const setTimeCount = payload => { dispatch( setTimeCountAction( payload ) ) };

  useEffect( () => {
    totalAnsweringTimer.current = createTimer( updateTotalAnsweringTime );
    totalAnsweringTimer.current.start();
    answeringTimer.current = createTimer( updateAnsweringTime );
    return () => {
      totalAnsweringTimer.current.clear();
    };
  }, [] );

  const updateTotalAnsweringTime = useCallback( ( time ) => {
    const date = new Date( time );
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    setAnsweringInfo( { displayTime : `${ minutes < 10 ? `0${ minutes }` : minutes }:${ seconds < 10 ? `0${ seconds }` : seconds }` } );
    setTimeCount( { totalAnsweringTime : Math.floor( time / 1000 ) } );
  }, [] );

  const updateAnsweringTime = useCallback( ( time ) => {
    setTimeCount( { answeringTime : time } );
  }, [] );

  useEffect( () => {
    if ( answeringQuestions.data.qstCd ) {
      answeringTimer.current.start();
      return () => {
        answeringTimer.current.clear();
      };
    }
  }, [ answeringQuestions.data.qstCd ] );

  return props.children || null;

};

export default Timer;
